export const FETCH_MAIL_SENT = 'FETCH_MAIL_SENT'
export const GET_MAIL_SENT = 'GET_MAIL_SENT'
export const ADD_MAIL_SENT = 'ADD_MAIL_SENT'
export const REMOVE_MAIL_SENT = 'REMOVE_MAIL_SENT'

